import en from './en';
import zhCN from './zh_CN';
import zhHK from './zh_HK';

export default {
 'zh_HK': zhHK,
 'en': en,
 'zh_CN': zhCN,
}